<template>
  <el-config-provider>
    <el-container :class="[
        'wrapper-layout','has-tab',sideCollapse ? 'collapse' : '',
      ]">
      <!-- 核心菜单  -->
      <el-aside :width="sideWidth">
        <div class="wrapper-logo">
          <span>系统管理后台</span>
        </div>
        <div class="side-menu-wrapper">
          <div class="side-menu2">
            <global-menu
                :collapse="sideCollapse"
                :menus="menus"
                :openKeys="openKeys"
                :selectedKey="selectedKey"
                @changeOpenKeys="changeOpenKeys"
                @changeSelectedKey="changeSelectedKey"
            ></global-menu>
          </div>
        </div>
      </el-aside>
      <el-container style="width: 0px">
        <!-- 布局头部 -->
        <el-header class="wrapper-header">
          <el-menu class="wrapper-layout-left" mode="horizontal" :ellipsis="false">
            <el-menu-item @click="collapse">
              <el-icon>
                <Expand v-if="sideCollapse" />
                <Fold v-else />
              </el-icon>
            </el-menu-item>
            <el-menu-item class="hidden-xs-only">
              <GlobalBreadcrumb></GlobalBreadcrumb>
            </el-menu-item>
            <el-menu-item class="hidden-xs-only" @click="refresh">
              <el-icon><RefreshRight /></el-icon>
            </el-menu-item>
          </el-menu>
          <!-- 菜单分组 -->
          <el-menu class="wrapper-layout-right" mode="horizontal" :ellipsis="false">
            <el-menu-item>
              <i class="el-icon jk-icon-tongzhi"></i>
            </el-menu-item>
            <el-menu-item>
              <el-dropdown placement="bottom-end">
                <div class="wrapper-user">
                  <img src="@/assets/images/user.png" alt="">
                  <div class="wrapper-user-info">
                   {{ userStore.userInfo.account }}
                  </div>
                </div>
                <template #dropdown>
                  <el-dropdown-menu class="header-menu-dropdown-menu">
                    <el-dropdown-item @click="router.push('/auth/admin-info')">个人中心</el-dropdown-item>
<!--                    <el-dropdown-item @click="toSystemSet">系统设置</el-dropdown-item>-->
                    <el-divider />
                    <el-dropdown-item @click="logOut">注销登录</el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </el-menu-item>
          </el-menu>
        </el-header>
        <el-main class="wrapper-main">
          <global-tab></global-tab>
          <global-content></global-content>
        </el-main>
      </el-container>
    </el-container>
  </el-config-provider>
</template>

<script>
export default {
  name: "BasicLayout"
}
</script>
<script setup>
import {ElConfigProvider} from 'element-plus'
import {computed, onMounted, ref} from "vue";
import {useMenu} from "@/layouts/composable/useMenu";
import {useUserStore} from "@/store/module/user";
import {useRouter} from "vue-router";
import GlobalContent from './global/GlobalContent.vue'
import GlobalBreadcrumb from './global/GlobalBreadcrumb.vue'
import GlobalTab from './global/GlobalTab.vue'
import GlobalMenu from './global/GlobalMenu.vue'
import {logout} from "@/utils/make";

const userStore = useUserStore()
const sideCollapse = ref(false)
const sideWidth = computed(() => sideCollapse.value ? '70px' : '220px')
const router = useRouter()

const {
  selectedKey,
  openKeys,
  menus,
  changeSelectedKey,
  changeOpenKeys
} = useMenu()

onMounted(() => {
  if (document.body.clientWidth < 768) {
    sideCollapse.value = true
  }
  userStore.loadMenus()
  userStore.loadAuthRule()
  userStore.updateUserInfo()
})


const collapse = () => {
  sideCollapse.value = !sideCollapse.value
}

const refresh = () => {
  userStore.routerAlive = false
  setTimeout(function () {
    userStore.routerAlive = true
  }, 500)
}

const logOut = () => {
  logout()
  router.push('/login')
}
</script>

<style>

</style>
